<template>
  <div class="c-drawer">
    <router-link
      class="c-drawer__logo"
      :to="{ name: RouteName.HOME }"
      @click.native="close"
    >
      <img
        :alt="tenantLogoAlt"
        :src="tenantLogoSrc"
      >
    </router-link>
    <template v-for="(group, index) in items">
      <div
        :key="`${group.name}-${index}`"
        class="c-drawer-column"
      >
        <template v-for="(element, id) in group">
          <template v-if="isItemVisible(element)">
            <div class="c-drawer-column__title">
              <v-link
                :key="`${element.name}-${index}-${id}`"
                :to="element.url || element.route"
                class="o-typography__headline5 o-typography--action"
                target="_blank"
                @click.native="close"
              >
                {{ element.name }}
              </v-link>
              <i
                v-if="hasSubcategories(element)"
                class="o-icon o-icon--right c-drawer-column__arrow"
                :class="{ 'is-open' : isSubcategoryOpened(element.id) }"
                @click="openCategoriesList(element.id)"
              ></i>
            </div>
            <div class="c-drawer-column__separator"></div>
            <div
              v-if="hasSubcategories(element) && isSubcategoryOpened(element.id)"
              class="c-drawer-column__wrapper"
            >
              <template v-for="subcategory in element.subcategories">
                <router-link
                  :key="subcategory.id"
                  :to="subcategory.route"
                  class="o-typography__headline6 o-typography--action c-drawer-column__item "
                  @click.native="close"
                >
                  {{ subcategory.name }}
                </router-link>
              </template>
            </div>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
  import { RouteName } from '@/shared/enums';
  import { tenantMixin } from '@/shared/mixins';
  import { generateUUID } from '@/shared/utils';
  import { VLink } from '@/index/shared/components';
  import { onboardingMixin } from '@/index/shared/mixins';

  export default {
    components: {
      VLink,
    },
    enums: {
      RouteName,
    },
    mixins: [
      onboardingMixin,
      tenantMixin,
    ],
    data() {
      return {
        menu: this.$services.resolve('menu'),
        subscriber: this.$services.resolve('subscriber'),
        categories: this.$services.resolve('categories'),
        openedCategoriesList: [],
      };
    },
    computed: {
      categoryItems() {
        if (this.subscriber.isKidsTheme) {
          return this.menu.data.desktopKidsDrawer || [];
        }
        return this.menu.data.desktopDrawer || [];
      },
      items() {
        return this.categoryItems?.map((column) => column.map((type) => {
          const subcategories = this.categories.collection.records
            .filter((record) => record.label === type.label)
            .map((subcategory) => {
              return {
                ...subcategory,
                id: generateUUID(subcategory.label || subcategory.name),
                route: this.getCategoryRoute(subcategory, subcategory.label),
              };
            })
            .sort(this.sortByName);
          return {
            ...type,
            subcategories,
            id: generateUUID(type.label || type.name),
            route: this.getCategoryRoute(type, type.label),
          };
        }));
      },
    },
    watch: {
      items: 'resetOpenCategories',
    },
    methods: {
      hasSubcategories(element) {
        return element.categories && element.subcategories.length;
      },
      isSubcategoryOpened(elementId) {
        return this.openedCategoriesList.includes(elementId);
      },
      resetOpenCategories() {
        this.openedCategoriesList = [];
      },
      openCategoriesList(elementId) {
        if (this.isSubcategoryOpened(elementId)) {
          this.openedCategoriesList = this.openedCategoriesList.filter((id) => id !== elementId);
        } else {
          this.openedCategoriesList.push(elementId);
        }
      },
      close() {
        this.$emit('close');
      },
      isItemVisible(item) {
        if (this.isLightMenu) {
          return false;
        }

        return !item.isLogged || (item.isLogged && this.subscriber.isLogged);
      },
      sortByName(a, b) {
        return a.name.localeCompare(b.name, this.subscriber.currentLanguage.toLowerCase());
      },
      getCategoryRoute(category, label) {
        if (!category) {
          return {
            name: RouteName.CATALOG,
            params: {
              label,
            },
          };
        }

        if (category.url) {
          return {
            path: category.url,
          };
        }

        if (category.label && !category.slug) {
          return {
            path: `/${category.label}`,
          };
        }

        return {
          name: RouteName.CATALOG_WITH_CATEGORY,
          params: {
            label,
            slug: category.slug,
            id: category.id,
          },
        };
      },
    },
  };
</script>
